<div class="flex justify-between bg-grey-veryLight mb-3 p-2">
	<app-button
		[loading]="buttonLoading"
		[icon]="ICON.BACK"
		size="small"
		(click)="beforeClose()"
		>Back to file</app-button
	>
	<div class="flex items-center">
		<atomic-matter-type-icon [fileType]="fileType"></atomic-matter-type-icon>
		<span class="mx-3">{{ matterNumber }}</span>
		<span>{{ matterName }}</span>
	</div>
</div>

<div *ngIf="loading" class="flex flex-1 flex-col justify-center items-center">
	<div class="w-64">
		<img src="/assets/images/integrations/chicago-title-logo.svg" />
	</div>
	<div class="mt-10 flex items-center">
		<app-icon
			[icon]="ICON.LOADING"
			class="text-4xl mr-3 text-grey"
			[spin]="true"
		></app-icon>
		<h4 class="text-grey">
			<span *ngIf="sendingData">Sending Data to Chicago</span>
			<span *ngIf="gettingStatus">Updating order status</span>
		</h4>
	</div>
</div>

<div
	*ngIf="errors?.length > 0"
	class="flex flex-1 flex-col justify-center items-center"
>
	<div class="w-20">
		<img src="/assets/images/integrations/chicago-title-logo.svg" />
	</div>
	<div class="mt-10 flex flex-col items-center justify-center">
		<h3>
			<app-icon [icon]="ICON.WARNING" class="text-orange mr-5"></app-icon>
			Unable to send data to Chicago
		</h3>
		<ul class="mt-5">
			<li *ngFor="let error of errors">{{ error }}</li>
		</ul>
	</div>
</div>

<div class="flex flex-1">
	<div class="flex flex-col flex-1 w-full" *ngIf="iframeUrl">
		<iframe
			id="chicago-iframe"
			[src]="iframeUrl"
			width="100%"
			height="100%"
			class="flex flex-1"
		></iframe>
	</div>
</div>
